import { Connect, Message, SocketObservable } from '@genesislcap/foundation-comms';
import { DI } from '@microsoft/fast-foundation';

export interface IArteriaNegotiationService {
  getArteriaNegotiations(criteria?: string): SocketObservable<Message>;
  getArteriaNegotiation(criteria?: string): Promise<Message<any>>;
}

class ArteriaNegotiationServiceImpl implements IArteriaNegotiationService {
  constructor(@Connect private connect: Connect) {}

  getArteriaNegotiations(criteria?: string): SocketObservable<Message<any>> {
    const request: any = this.connect.stream(
      'ARTERIA_NEGOTIATION',
      (streamMessage: Message) => {
        () => {};
      },
      (x) => {},
      { CRITERIA_MATCH: criteria }
    );

    return request;
  }

  getArteriaNegotiation(criteria?: string): Promise<Message<any>> {
    return this.connect.snapshot('ARTERIA_NEGOTIATION', { CRITERIA_MATCH: criteria });
  }
}

export const IArteriaNegotiationService = DI.createInterface<IArteriaNegotiationService>((x) =>
  x.singleton(ArteriaNegotiationServiceImpl)
);
